/**
 * Black-Swan Event Bus
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 */

import Vue from 'vue'

const Bus = new Vue({
  data: {
    eventBusQueue: []
  },
  methods: {
    /*
      이름 : addEventBus
      설명 : EventBus를 생성하고 연결합니다. 이벤트 이름은 내부 모델인 eventBusQueue에서 관리합니다.
    */
    addEventBus (eventName, callbackFunc) {
      this.$on(eventName, callbackFunc)
      this.eventBusQueue.push(eventName)
    },
    /*
      이름 : removeEventBus
      설명 : 파라미터로 전달된 이름을 가지는 이벤트를 제거합니다.
    */
    removeEventBus (eventName) {
      this.$off(eventName)
      this.eventBusQueue = this.eventBusQueue.filter(value => value !== eventName)
    },
    /*
      이름 : removeAllEventBus
      설명 : 등록된 모든 이벤트를 제거합니다.
    */
    removeAllEventBus () {
      for (const eventBus of this.eventBusQueue) {
        this.$off(eventBus)
      }
      this.eventBusQueue = []
    }
  }
})

export default Bus
